
import Menu from './components/Menu';
import React from 'react';
import { IonApp, IonRouterOutlet, IonSplitPane } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/style.css';

import Home from './pages/Home';
import Runes from './pages/Runes';
import RuneDetails from './pages/RuneDetails';
import Runewords from './pages/Runewords';
import RunewordsFinder from './pages/RunewordsFinder';
import runewords from './data/runewords';
import RunewordDetails from './pages/RunewordDetails';
import { setupConfig } from '@ionic/react';
import { Plugins } from '@capacitor/core';
import Grail from './pages/Grail';
import GrailItemType from './pages/GrailItemType';
import GrailItemDetails from './pages/GrailItemDetails';
import CubeRecipes from './pages/CubeRecipes';
import RuneRecipes from './pages/RuneRecipes';
import GemRecipes from './pages/GemRecipes';
import { AdMobPlus, BannerAd } from '@admob-plus/capacitor'
import PreparationRecipes from './pages/PreparationRecipes';
import RepairsRecharchesRecipes from './pages/RepairsRecharchesRecipes';
import RecyclingRecipes from './pages/RecyclingRecipes';
import UpgradingRecipes from './pages/UpgradingRecipes';
import Mule from './pages/Mule';
import MuleDetails from './pages/MuleDetails';
import PrivacyPolicy from './pages/PrivacyPolicy';
import About from './pages/About';

window.foundRunewords = runewords;

if(!localStorage.getItem('favRunewords')) localStorage.setItem('favRunewords',JSON.stringify([]));

// const options = {
//   adId: 'ca-app-pub-8972085867877753/3634990157',
//   adSize: BannerAdSize.SMART_BANNER,
//   position: BannerAdPosition.BOTTOM_CENTER,
//   margin: 0,
//   // isTesting: true
// }

class App extends React.Component {


  async componentDidMount() {
    const res = AdMobPlus.requestTrackingAuthorization()
    const banner = new BannerAd({
      adUnitId: 'ca-app-pub-8972085867877753/3634990157',
    })
    await banner.show()
  }
  
  render() {
    return (
      <IonApp>
        <IonReactRouter>
              <IonRouterOutlet id="main">
              <Route path="/home" component={Home} exact />

              <Route path="/runes" component={Runes} exact />
              <Route path="/runes/:rune" component={RuneDetails} exact />
              
              <Route path="/runewordsFinder" component={RunewordsFinder} exact />
              <Route path="/finderResults" component={Runewords} exact />
              <Route path="/runewords/:id" component={RunewordDetails} exact />
              <Route path="/runewords" component={Runewords} exact />

              <Route path="/cuberecipes" component={CubeRecipes} exact />
              <Route path="/cuberecipes/upgradeItems" component={UpgradingRecipes} exact />
              <Route path="/cuberecipes/runes" component={RuneRecipes} exact />
              <Route path="/cuberecipes/gems" component={GemRecipes} exact />
              <Route path="/cuberecipes/preparation" component={PreparationRecipes} exact />
              <Route path="/cuberecipes/repairesrecharges" component={RepairsRecharchesRecipes} exact />
              <Route path="/cuberecipes/recycling" component={RecyclingRecipes} exact />
              
              <Route path="/grail" component={Grail} exact />
              <Route path="/grail/:type" component={GrailItemType} exact />
              <Route path="/grail/:type/:name" component={GrailItemDetails} exact />

              <Route path="/mule" component={Mule} exact />
              <Route path="/mule/:name" component={MuleDetails} exact />

              <Route path="/about" component={About} exact />
              <Route path="/privacy" component={PrivacyPolicy} exact />

              <Redirect from="/" to="/home" exact />
            </IonRouterOutlet>
        </IonReactRouter>
      </IonApp>
    )
  }
}

export default App;
 